import { FETCH_VOLUNTEER_LANGUAGES } from '../../constants/actionTypes'

export default (vlnVolunteerLanguages = [], action) => {
    switch (action.type) {
        case FETCH_VOLUNTEER_LANGUAGES:
            return action.payload;
        default:
            return vlnVolunteerLanguages;
    }
}